/**
 * @class ProductCard
 * @classdesc The class for a product card.
 *
 * @extends Core.Component
 */
export default class ProductCard extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.productImage = this.el.querySelector('[data-product-image]');
    this.productVariantColorLabel = this.el.querySelector('[data-variant-color-label]');
  }

  onMount() {
    this.swatches = this.query('product-card-swatches');
    this.quickAddButton = this.el.querySelector('[data-quick-add-button]');
    this.quickAddMobile = this.query('button-floating');
    this.quickshop = Core.Components.getComponent('quickshop');

    if (this.swatches) {
      this.events.register(this.swatches.el, 'swatch:update', e => {
        this._updateSelectedVariant(e.detail.color);
      });
    }

    // Handle quick add button click to show quickshop
    if (this.quickAddButton) {
      this.events.register(this.quickAddButton, 'mouseover', e => {
        e.stopPropagation();
        const { productLink } = this.quickAddButton.dataset;
        this.quickshop.loadQuickshop({ productLink });
      });

      this.events.register(this.quickAddButton, 'click', e => {
        e.stopPropagation();
        const { productLink } = this.quickAddButton.dataset;
        this.quickshop.open(this.quickAddButton, { productLink });
      });
    }

    if (this.quickAddMobile) {
      this.events.register(this.quickAddMobile.el, 'click', e => {
        e.stopPropagation();
        const { productLink } = this.quickAddButton.dataset;
        this.quickshop.open(this.quickAddMobile.el, { productLink });
      });
    }
  }

  onDismount() {
    this.events.unregisterAll();
  }

  /**
   * This method will display the image for the variant of the color requested, if one exists.
   * @param {String} color The color of the variant to switch to
   * @private
   */
  _updateSelectedVariant(color) {
    const variantImagesContainer = this.el.querySelector('[data-variant-images]');
    const variantImages = variantImagesContainer.querySelectorAll('[data-variant-image]');
    const currentImage = this.el.querySelector(`[data-variant-image="${color}"]`);

    variantImagesContainer.classList.add('hidden');

    variantImages.forEach(image => {
      image.classList.add('hidden');
    });

    if (currentImage) {
      variantImagesContainer.classList.remove('hidden');
      currentImage.classList.remove('hidden');
    }

    if (this.productVariantColorLabel) {
      this.productVariantColorLabel.innerHTML = color;
    }
  }
}
